/** Display copy for CURRENT PLAN on Account & Billing.

Machine plan key stays `pro`. Swap PLAN_NAMES.pro later for hunting wording.
*/

export const PLAN_NAMES = {
  free: 'Free',
  pro: 'Yona Pro',
};

export const PLAN_CTA = {
  upgrade: 'Upgrade',
  manage: 'Manage billing',
};

export function planDisplayName(plan) {
  return PLAN_NAMES[plan] || PLAN_NAMES.free;
}

export function planBlurb(plan) {
  if (plan === 'pro') {
    return 'Clubs and ground-management tools are included. $5/month.';
  }
  return 'Clubs and ground-management tools. $5/month.';
}

export function billingFlagFromSearch(search) {
  const raw = String(search || '');
  const query = raw.startsWith('?') ? raw.slice(1) : raw;
  return new URLSearchParams(query).get('billing');
}

export function formatPlanRenewsAt(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
